import React from "react";
import styled from "styled-components";
import { get } from "lodash";
import PrismicRichText from "../components/PrismicRichText";
import * as colors from "../constants/colors";

const StlRoot = styled.section`
  padding: 28px 20px;
  color: ${colors.textDarkest};
  @media (min-width: 900px) {
    padding: 64px;
  }
`;

const StlInner = styled.div`
  max-width: 1280px;
  margin: 0 auto;
`;

const StlGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 36px;

  @media (min-width: 900px) {
    grid-template-columns: minmax(0, 1.2fr) minmax(0, 0.8fr);
    gap: 64px;
    align-items: start;
  }
`;

const StlLeftCol = styled.div`
  display: grid;
  gap: 32px;

  @media (min-width: 900px) {
    gap: 48px;
  }
`;

const StlCopySection = styled.div`
  color: inherit;

  h1,
  h2,
  h3 {
    margin: 0 0 20px;
    color: inherit;
  }

  p {
    margin: 0 0 20px;
    color: inherit;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;

const StlRightCol = styled.div`
  color: inherit;
`;

const StlItemList = styled.div`
  margin-top: 24px;
  display: grid;
  gap: 12px;
`;

const StlItem = styled.article`
  display: flex;
  align-items: center;
  gap: 20px;
  border: 1px solid ${colors.gray4};
  border-radius: 3px;
  padding: 10px;
  @media (min-width: 900px) {
    padding: 20px;
  }
`;

const StlItemImageWrap = styled.div`
  width: 42px;
  min-width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StlItemImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const ThreeInfoBlocks = (slice) => {
  const firstCopySection = get(slice, "primary.first_copy_section");
  const secondCopySection = get(slice, "primary.second_copy_section");
  const thirdCopySection = get(slice, "primary.third_copy_section");
  const items = get(slice, "items", []);

  return (
    <StlRoot>
      <StlInner>
        <StlGrid>
          <StlLeftCol>
            {firstCopySection && (
              <StlCopySection>
                <PrismicRichText render={firstCopySection} />
              </StlCopySection>
            )}
            {secondCopySection && (
              <StlCopySection>
                <PrismicRichText render={secondCopySection} />
              </StlCopySection>
            )}
          </StlLeftCol>
          <StlRightCol>
            {thirdCopySection && (
              <StlCopySection>
                <PrismicRichText render={thirdCopySection} />
              </StlCopySection>
            )}
            {!!items.length && (
              <StlItemList>
                {items.map((item, index) => {
                  const imageUrl = get(item, "third_section_logo.url");
                  const imageAlt = get(item, "third_section_logo.alt", "");
                  const itemCopy = get(item, "third_section_bullet_points");

                  if (!itemCopy) {
                    return null;
                  }

                  return (
                    <StlItem key={`three-info-item-${index}`}>
                      {imageUrl && (
                        <StlItemImageWrap>
                          <StlItemImage src={imageUrl} alt={imageAlt} />
                        </StlItemImageWrap>
                      )}
                      {itemCopy && <PrismicRichText render={itemCopy} />}
                    </StlItem>
                  );
                })}
              </StlItemList>
            )}
          </StlRightCol>
        </StlGrid>
      </StlInner>
    </StlRoot>
  );
};

export default ThreeInfoBlocks;
